module.exports = __webpack_public_path__ + "img/smile.011e381e.svg";